export enum TEMPLATE_VIEWS {
  NEW_TEMPLATE = 'new-template',
  NEW_AREA = 'new-area',
  AREA = 'area',
}
